import { SchematicAPI } from '../actions/schematicAPI';
import Constants from '../constants/constants';
import { dispatcher } from '../dispatcher/dispatcher';
import { pollStore } from '../stores/poll';
import { UserActions } from '../actions/userActions';

const { ActionTypes } = Constants;
var Actions = Constants.restrictionActions;

export const PollActions = {

    initializePoll: function () {
        dispatcher.dispatch({
            type: ActionTypes.INITIALIZE_POLL
        });
    },

    mfNoResponseYetOnPoll: function (id) {
        dispatcher.dispatch({
            type: ActionTypes.NO_TSS_RESPONSE_ON_POLL
        });
    },

    blockScreen: function () {
        dispatcher.dispatch({
            type: ActionTypes.SUBMITTING_TO_SERVER
        });
    },

    unblockScreen: function () {
        dispatcher.dispatch({
            type: ActionTypes.SUBMIT_TO_SERVER_VALIDATE_MP_FINISHED
        });
    },

    stopPollingDueToMaxAttemptsReached: function (id) {
        dispatcher.dispatch({
            type: ActionTypes.REMOVE_POLL_ID,
            id: id,
            message: [{
                field: 'pollTimeout',
                message: 'Restriction processing is taking longer than normal. You should consider your submission NOT in effect. Please check back in a few minutes to see if processing has finished. If you see your item in the list, you may consider it in effect',
                type: 'warning'
            }]
        });

    },
    //                message: [{field:'pollTimeout', message: "I have no idea what to tell you, we haven't gotten a response yet and don't know the state of your submission. Here is what we do know, we sent it to TSS. That's it. Nothing more. You could try to submit again, or refresh the list you expect it to show up in and see if its there. Async sucks eh?", type: 'error'}]

    mfErrorReturnedFromPoll: function (vr) {
        dispatcher.dispatch({
            type: ActionTypes.MF_ERROR_RETURNED,
            id: vr.data.syncId,
            form: vr.data,
            message: vr.errors
        });
    },

    mfSuccessReturnedFromPoll: function (req) {//req here is really a validationResult telling whether this succeeded or not...
        //determine the action we were waiting on, alert the user, stop polling that ID
        var syncId = req.syncId;
        var op = pollStore.opForId(syncId);
        var formTypeSubmitted = "";
        if (req.restrictionDetail) {
            if (req.restrictionDetail.formADetail)
                formTypeSubmitted = "A";

            if (req.restrictionDetail.formBDetail)
                formTypeSubmitted = "B";

            if (req.restrictionDetail.formCDetail)
                formTypeSubmitted = "C";

            if (req.restrictionDetail.tcmDetail)
                formTypeSubmitted = "T";
        }
        switch (op) {
            case Actions.SUBMIT_REQUEST:
                SchematicAPI.resetSchematicNoPrompt();
                dispatcher.dispatch({
                    type: ActionTypes.POLL_SUCCESSFUL,
                    message: [{
                        message: "Request GR{id} has been successfully submitted".replace("{id}", syncId),
                        type: 'info',
                        field: 'submitSuccess'
                    }],
                    formTypeSubmitted: formTypeSubmitted //If this field is given, it will redirect the user to another tab on success
                });
                break;
            case Actions.UPDATE_REQUEST:
                SchematicAPI.resetSchematicNoPrompt();
                dispatcher.dispatch({
                    type: ActionTypes.POLL_SUCCESSFUL,
                    message: [{
                        message: "Request GR{id} has been successfully updated".replace("{id}", syncId),
                        type: 'info',
                        field: 'submitSuccess'
                    }]
                });
                break;
            case Actions.DELETE_REQUEST:
                SchematicAPI.resetSchematicNoPrompt();
                dispatcher.dispatch({
                    type: ActionTypes.POLL_SUCCESSFUL,
                    message: [{
                        message: "Request GR{id} has been successfully deleted".replace("{id}", syncId),
                        type: 'info',
                        field: 'submitSuccess'
                    }]
                });
                break;
            case Actions.SLODT_RESTRICTION:
                SchematicAPI.resetSchematicNoPrompt();
                dispatcher.dispatch({
                    type: ActionTypes.POLL_SUCCESSFUL,
                    message: [{
                        message: "Restriction {id} successfully updated".replace("{id}", req.restrictionDetail.controlNumber),
                        type: 'info',
                        field: 'submitSuccess'
                    }]
                });
                break;
            case Actions.FORMCDT_RESTRICTION:
                SchematicAPI.resetSchematicNoPrompt();
                dispatcher.dispatch({
                    type: ActionTypes.POLL_SUCCESSFUL,
                    message: [{
                        message: "Restriction {id} successfully updated".replace("{id}", req.restrictionDetail.controlNumber),
                        type: 'info',
                        field: 'submitSuccess'
                    }],
                    formTypeSubmitted: formTypeSubmitted
                });
                break;
            case Actions.TCMDT_RESTRICTION:
                SchematicAPI.resetSchematicNoPrompt();
                dispatcher.dispatch({
                    type: ActionTypes.POLL_SUCCESSFUL,
                    message: [{
                        message: "Restriction {id} successfully updated".replace("{id}", req.restrictionDetail.controlNumber),
                        type: 'info',
                        field: 'submitSuccess'
                    }],
                    formTypeSubmitted: formTypeSubmitted //If this field is given, it will redirect the user to another tab on success
                });
                break;
            case Actions.ISSUE_RESTRICTION:
                SchematicAPI.resetSchematicNoPrompt();
                dispatcher.dispatch({
                    type: ActionTypes.POLL_SUCCESSFUL,
                    message: [{
                        message: "Restriction {id} successfully issued".replace("{id}", req.restrictionDetail.controlNumber),
                        type: 'info',
                        field: 'submitSuccess'
                    }]
                });

                break;
            case Actions.APPROVE_REQUEST:
                SchematicAPI.resetSchematicNoPrompt();
                dispatcher.dispatch({
                    type: ActionTypes.POLL_SUCCESSFUL,
                    message: [{
                        message: "Restriction {id} successfully issued".replace("{id}", req.restrictionDetail.controlNumber),
                        type: 'info',
                        field: 'submitSuccess'
                    }]
                });
                break;
            case Actions.APPROVE_VERBAL_FORMA_RESTRICTION:
                SchematicAPI.resetSchematicNoPrompt();
                dispatcher.dispatch({
                    type: ActionTypes.POLL_SUCCESSFUL,
                    message: [{
                        message: "Request GR{id} has been successfully marked verbal".replace("{id}", syncId),
                        type: 'info',
                        field: 'submitSuccess'
                    }]
                });
                break;
            case Actions.TRANSFER_REQUEST:
                SchematicAPI.resetSchematicNoPrompt();
                dispatcher.dispatch({
                    type: ActionTypes.POLL_SUCCESSFUL,
                    message: [{
                        message: "Request GR{id} has been successfully transferred".replace("{id}", syncId),
                        type: 'info',
                        field: 'submitSuccess'
                    }]
                });
                break;
            case Actions.REJECT_REQUEST:
                SchematicAPI.resetSchematicNoPrompt();
                dispatcher.dispatch({
                    type: ActionTypes.POLL_SUCCESSFUL,
                    message: [{
                        message: "Request GR{id} has been successfully rejected".replace("{id}", syncId),
                        type: 'info',
                        field: 'submitSuccess'
                    }]
                });
                break;

            case Actions.VOID_RESTRICTION:
                SchematicAPI.resetSchematicNoPrompt();
                dispatcher.dispatch({
                    type: ActionTypes.POLL_SUCCESSFUL,
                    message: [{
                        message: "Restriction {id} successfully voided".replace("{id}", req.restrictionDetail.controlNumber),
                        type: 'info',
                        field: 'submitSuccess'
                    }]
                });
                break;
            case Actions.MODIFY_RESTRICTION:
            case Actions.APPROVE_REQUEST_TO_MODIFY:
                SchematicAPI.resetSchematicNoPrompt();
                dispatcher.dispatch({
                    type: ActionTypes.POLL_SUCCESSFUL,
                    message: [{
                        message: "Restriction {orcn} successfully voided.".replace("{orcn}", pollStore.getPreviousFormAControlNumber()) +
                            "  Restriction {id} successfully created.".replace("{id}", req.restrictionDetail.controlNumber),
                        type: 'info',
                        field: 'submitSuccess'
                    }]
                });
                break;
            case Actions.MODIFY_FORM_C_RESTRICTION:
                SchematicAPI.resetSchematicNoPrompt();
                dispatcher.dispatch({
                    type: ActionTypes.POLL_SUCCESSFUL,
                    message: [{
                        message: "Restriction {orcn} successfully voided.".replace("{orcn}", pollStore.getPreviousFormAControlNumber()) +
                            "  Restriction {id} successfully created.".replace("{id}", req.restrictionDetail.controlNumber),
                        type: 'info',
                        field: 'submitSuccess'
                    }]
                });
                break;
            default:
                console.log('unknown op');
        }

        // UserActions.getActiveOverride({ userId: window.gritConfig.userId });

        dispatcher.dispatch({
            type: ActionTypes.REMOVE_POLL_ID,
            id: syncId
        })
    }
};
